import { CountryStateInterface } from '.';

function state(): CountryStateInterface {
  return {
    countries: [],
  };
}

export default state;
